import React from 'react';
import SocialMedia from "../SocialMedia";
import { Box, Text } from "grommet";

const Footer = () => {
    return (
        <Box>
            <Box direction="column" align="center">
                <Box gap="large" align="start" pad={{ horizontal: 'large' }}>
                    <SocialMedia />
                </Box>
                <Box gap="large" align="start" pad={{ horizontal: 'large', vertical: 'large' }}>
                    <Text>Copyright @ Tan Khai Ze</Text>
                </Box>
            </Box>
        </Box>
    )
}

export default Footer;